import { errorToast } from './toastAlert'

export const detectBrowserCoordinates = (successCallback, errorCallback) => {
  if (typeof navigator.permissions !== 'undefined') {
    navigator.permissions.query({ name: 'geolocation' }).then(
      (result) => {
        if (result.state === 'granted' || result.state === 'prompt') {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              App.State.userCoordinates = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              }
              successCallback()
            },
            () => {
              errorToast({
                title:
                  'Sorry, but the coordinates could not be detected. Please check your browser settings',
              })
              errorCallback()
            },
            { enableHighAccuracy: true }
          )
        } else {
          errorToast({
            title:
              'Sorry, but permissions to access location services are missing. Please check your settings.',
          })
          errorCallback()
        }
      },
      () => {
        errorToast({ title: 'Location services are not supported.' })
        errorCallback()
      }
    )
  } else {
    errorCallback()
  }
}
